import {map} from 'lodash';
import {useNavigate} from 'react-router';

import Button from 'components/Button';
import TextFilter from 'components/Table/Filter/Text';
import VirtualizedTable from 'components/Table/Virtualized';
import {defaultViewLinkColumn, fixedColumnStyle} from 'components/Table/columnHelpers';
import Tag from 'components/Tag';
import {TechStackStyles} from 'conf/techStackColors';


const gitHubColumns = [
  {
    id: 'gitHubUsername',
    Header: 'GitHub Username',
    accessor: 'gitHubUsername',
    Cell: ({value}) => (<a href={`https://github.com/${value}`} target="_blank" rel="noopener noreferrer">{value}</a>),
    Filter: TextFilter,
    sortable: true,
    ...fixedColumnStyle(200),
  },
  {
    id: 'languageStats',
    Header: 'Tech Stacks',
    accessor: 'languageStats',
    Cell: renderTechStackCell,
    Filter: TextFilter,
    sortable: true,
  },
  {
    id: 'commitFreqStats',
    Header: 'Commit Activity Status',
    accessor: 'commitFreqStats',
    Cell: renderCommitFreqStats,
    ...fixedColumnStyle(250),
  },
  {
    ...defaultViewLinkColumn,
    Cell: ViewLinkCell,
    ...fixedColumnStyle(100),
  },
];


export default function GitHubTable({data}) {
  return (
    <VirtualizedTable
      data={data}
      columns={gitHubColumns}
    />
  );
}

function renderTechStackCell({value}) {
  const techStacks = Object.keys(value);
  return (
    <div className="tagContainer">
      {map(techStacks, (val) => (<Tag key={val} style={TechStackStyles[val]} className="tag--sm">{val}</Tag>))}
    </div>
  );
}

export function renderCommitFreqStats({value}) {
  const periods = Object.keys(value);
  return (
    <div className="tagContainer">
      {
        map(periods, (period) => {
          if (period === '01Week') {
            return getStatus(value, period, 1, 'Last Week');
          } else if (period === '04Weeks') {
            return getStatus(value, period, 4, 'Last Month');
          } else if (period === '12Weeks') {
            return getStatus(value, period, 12, 'Last 3 Months');
          } else if (period === '26Weeks') {
            return getStatus(value, period, 26, 'Last 6 Months');
          } else if (period === '52Weeks') {
            return getStatus(value, period, 52, 'Last 12 Months');
          }
        })
      }
    </div>
  );
}


function getStatus(value, period, freq = 1, title) {
  let status;
  const val = value[period];
  if (val >= 15 * freq) {
    status = `🔥 ${title} - Very Active`;
  } else if (val < 15 * freq && val >= 8 * freq) {
    status = `✅ ${title} - Active`;
  } else if (val < 8 * freq && val >= 3 * freq) {
    status = `⚠️ ${title} - Moderate`;
  } else if (val < 3 * freq && val >= 1) {
    status = `💤 ${title} - Low`;
  } else {
    status = `❌ ${title} - Inactive`;
  }
  return (
    <div key={period}>
      <Tag style={TechStackStyles[val]} className="tag--sm">{status}</Tag>
    </div>
  );
}

function ViewLinkCell({value}) {
  const navigate = useNavigate();
  
  if (!value) {
    return '';
  }

  const handleClick = () => {
    const {gitHubUsername} = value;
    navigate(`/github/profile/${gitHubUsername}`, {state: {gitHubMetaData: value}});
  };
  
  return (
    <Button
      actionHandler={handleClick}
      className="btn btn-xs btn-primary"
      title="View Profile"
    >
      View Profile
    </Button>
  );
}
